import { crl8 } from 'app/curalate.globals';
import pendoTracker from './pendo-tracker';

crl8.userSessionPromise.then((session) => {
  pendoTracker.init(CURALATE_ENV.RELEASE, location.hostname, session);
});
